var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHaidiUserIconMultiColor = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--dlMultiColorPrimary)",
  d: "M10.777 8.513a5.279 5.279 0 0 1-2.81.82 5.279 5.279 0 0 1-2.81-.82 7.939 7.939 0 0 0-5.154 6.76.667.667 0 0 0 .664.727h14.6a.664.664 0 0 0 .664-.727 7.939 7.939 0 0 0-5.153-6.76Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--dlMultiColorSecondary)",
  d: "M7.967 8a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"
})));
export default SvgHaidiUserIconMultiColor;